<template>
  <div :class="$style.container">
    <DolphinSelector
      v-model="typeForm"
      :options="principalOptions"
      :class="$style.inputType"
    />
    <div
      v-if="model.type !== 'AnyAuthzPolicyPrincipal'"
      :class="$style.inputID"
    >
      <!-- TODO: idを直接入力するのではなくSelectorで選択できるようにする -->
      <p>対象のid:</p>
      <DolphinTextInput v-model="model.id" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
  AuthzPolicyPrincipalTypeValues,
  AuthzPolicyPrincipalTypeText,
} from '../types'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'

type AnyAuthzPolicyPrincipal = {
  type: 'AnyAuthzPolicyPrincipal'
}
type StaffAuthzPolicyPrincipal = {
  type: 'StaffAuthzPolicyPrincipal'
  id: string
}
type TeamAuthzPolicyPrincipal = {
  type: 'TeamAuthzPolicyPrincipal'
  id: string
}
export type AuthzPolicyPrincipalForm =
  | AnyAuthzPolicyPrincipal
  | StaffAuthzPolicyPrincipal
  | TeamAuthzPolicyPrincipal

const model = defineModel<AuthzPolicyPrincipalForm>({ required: true })

const typeForm = computed({
  get: () => model.value.type,
  set: value => {
    switch (value) {
      case 'AnyAuthzPolicyPrincipal':
        model.value = {
          type: value,
        }
        break
      case 'StaffAuthzPolicyPrincipal':
        model.value = {
          type: value,
          id: '',
        }
        break
      case 'TeamAuthzPolicyPrincipal':
        model.value = {
          type: value,
          id: '',
        }
        break
    }
  },
})

const principalOptions = computed(() =>
  AuthzPolicyPrincipalTypeValues.map(value => ({
    value,
    text: AuthzPolicyPrincipalTypeText[value],
  }))
)
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.inputType {
  width: 200px;
}

.inputID {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
